/* src/app/internal-admin/internal-admin-feature/internal-admin-feature.component.scss */
/*# sourceMappingURL=internal-admin-feature.component.css.map */
